import { AccountAccessLevel, AccountType } from 'types/account';
import { MerchantFlags } from 'types/routing';

export interface PartnerFeatures {
  pwc: boolean;
  cryptoPayout: boolean;
}

const isCryptoPayoutGloballyEnabled = (): boolean => window?.s4cConfig?.features?.cryptoPayout === true;

export const getPartnerFeatures = (accountType?: AccountType, merchantFlags?: MerchantFlags): PartnerFeatures => {
  if (accountType === AccountType.PSP || accountType === AccountType.Pwc_Group) {
    return { pwc: true, cryptoPayout: isCryptoPayoutGloballyEnabled() };
  }

  if (accountType === AccountType.Pwc) {
    return {
      pwc: merchantFlags?.pwcEnabled === true,
      cryptoPayout: merchantFlags?.cryptoPayoutEnabled === true && isCryptoPayoutGloballyEnabled(),
    };
  }

  return { pwc: false, cryptoPayout: false };
};

export const canManageAccount = (level: AccountAccessLevel): boolean =>
  level === AccountAccessLevel.Owner || level === AccountAccessLevel.Administrator;
